import script from "./CategorySetup.vue?vue&type=script&setup=true&lang=js"
export * from "./CategorySetup.vue?vue&type=script&setup=true&lang=js"

import "./CategorySetup.vue?vue&type=style&index=0&id=ffea21ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ffea21ba"]])

export default __exports__